/* eslint-disable prettier/prettier */
import React from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import expressConfig from "src/config/express.json";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import clsx from "clsx";
import { User } from "../../../facebook/upperComponent/types";
import useStyle from "../Styles";

interface ConnectedFbProps {
  user: User;
  logout: () => void;
  loading: boolean;
  isCollapsed: boolean;
}

const ConnectedFb: React.FC<ConnectedFbProps> = ({
  user,
  logout,
  loading,
  isCollapsed,
}) => {
  const { classes } = useStyle();

  const env = process.env.NODE_ENV || "development";
  const config = expressConfig[env];

  const scopes = [
    "public_profile",
    "email",
    "pages_show_list",
    "pages_read_engagement",
    "pages_manage_metadata",
    "business_management",
    "instagram_basic",
    "instagram_manage_messages",
  ].join(",");

  const instagramLoginUrl =
    `https://www.facebook.com/v20.0/dialog/oauth` +
    `?client_id=${config.facebook_app_id}` +
    `&redirect_uri=${encodeURIComponent(
      config.INSTAGRAM_LOGIN_FLOW_REDIRECT_URL,
    )}` +
    `&response_type=token` +
    `&auth_type=rerequest` +
    `&scope=${encodeURIComponent(scopes)}`;

  return (
    <Box className={clsx(classes.rootConnectedBox, isCollapsed && "collapsed")}>
      <Avatar
        alt={user?.name || ""}
        src={user?.picture?.data?.url || ""}
        className={clsx(classes.avatar, isCollapsed && "collapsed")}
      />
      <Typography
        variant="h6"
        noWrap
        className={clsx(classes.userName, isCollapsed && "collapsed")}
      >
        {user?.name || "User Account"}
      </Typography>

      <Box className={classes.actionGroup}>
        <Button
          variant="outlined"
          onClick={logout}
          className={classes.DisconnectButton}
        >
          Disconnect
        </Button>

        <Button
          className={classes.labelAddButton}
          id="user_dropdown"
          aria-controls={undefined}
          aria-haspopup="true"
          aria-expanded={undefined}
          disableElevation
          href={instagramLoginUrl}
          variant="contained"
          startIcon={<AddCircleIcon className={classes.labelAddIcon} />}
          endIcon={
            loading && <CircularProgress size={17} sx={{ color: "white" }} />
          }
        >
          Add Pages
        </Button>
      </Box>
    </Box>
  );
};

export default ConnectedFb;
